/**
 * Only render https image URLs; block javascript:/data:/relative injection.
 * Prefer S3 fee-proof paths when recognizable.
 */
export function isSafeFeeProofDisplayUrl(url) {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed) return false;
  if (/[<>"'`]/.test(trimmed)) return false;
  if (/^(javascript|data|vbscript|file):/i.test(trimmed)) return false;
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== "https:") return false;
    if (parsed.username || parsed.password) return false;
    return true;
  } catch {
    return false;
  }
}

export const FEE_PROOF_ACCEPT =
  "image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp";

export const FEE_PROOF_MAX_BYTES = 5 * 1024 * 1024;

export function validateFeeProofFile(file) {
  if (!file) return "Please choose an image file.";
  const allowed = new Set(["image/jpeg", "image/png", "image/webp"]);
  if (!allowed.has(file.type)) {
    return "Only JPEG, PNG, or WebP images are allowed.";
  }
  const name = String(file.name || "").toLowerCase();
  if (!/\.(jpe?g|png|webp)$/.test(name)) {
    return "Invalid file extension. Use .jpg, .jpeg, .png, or .webp.";
  }
  if (file.size > FEE_PROOF_MAX_BYTES) {
    return "Image must be 5 MB or smaller.";
  }
  return null;
}
